/**
 * A number, or a string containing a number.
 * @typedef {{type: string; userInformed: boolean; code: string; description: string; target; payload;}} LogInfo
 */
export const logEventType = {
  error: 'error',
  warning: 'warning',
  information: 'information'
};
export const logErrorType = {
  server: 'server',
  input: 'input',
  form: 'form'
};
export const logWarningType = {
  warning: 'warning'
};